var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-comp mt-auto"},[_c('p',{staticClass:"text-center mt-2 p-1"},[_vm._v(" © Copyright 2021 by Valuation BR. ")])])}]

export { render, staticRenderFns }